import { BALANCE_REQUEST } from "../types/GetBalance";

export const balanceRequest = (userId, token) => ({
    type: BALANCE_REQUEST,
    payload: { userId, token },
  });
  